import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { RequireAuth, CHANGE_PASSWORD_PATH } from '@/features/auth/RequireAuth';
import { RequirePermission } from '@/features/auth/RequirePermission';
import { LoginPage } from '@/features/auth/LoginPage';
import { ChangePasswordPage } from '@/features/auth/ChangePasswordPage';
import { AccountPage } from '@/features/account/AccountPage';
import { UsersPage } from '@/features/users/UsersPage';
import { RolesPage } from '@/features/roles/RolesPage';
import { AuditPage } from '@/features/audit/AuditPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { MonthlyPage } from '@/features/reports/MonthlyPage';
import { DailyPage } from '@/features/reports/DailyPage';
import { AffiliatesPage } from '@/features/affiliates/AffiliatesPage';
import { AffiliateDetailPage } from '@/features/affiliates/AffiliateDetailPage';
import { ProductsPage } from '@/features/products/ProductsPage';
import { ImportsPage } from '@/features/imports/ImportsPage';
import { ImportDetailPage } from '@/features/imports/ImportDetailPage';
import { SettingsPage } from '@/features/settings/SettingsPage';
import { NotFoundPage } from '@/app/NotFoundPage';

const guarded = (
  permission: Parameters<typeof RequirePermission>[0]['permission'],
  el: React.ReactNode,
) => <RequirePermission permission={permission}>{el}</RequirePermission>;

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: CHANGE_PASSWORD_PATH,
    element: (
      <RequireAuth>
        <ChangePasswordPage />
      </RequireAuth>
    ),
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: guarded('dashboard.read', <DashboardPage />) },
      { path: 'mensal', element: guarded('reports.read', <MonthlyPage />) },
      { path: 'diario', element: guarded('reports.read', <DailyPage />) },
      { path: 'afiliados', element: guarded('reports.read', <AffiliatesPage />) },
      { path: 'afiliados/:id', element: guarded('reports.read', <AffiliateDetailPage />) },
      { path: 'produtos', element: guarded('reports.read', <ProductsPage />) },
      { path: 'importacoes', element: guarded('imports.read', <ImportsPage />) },
      { path: 'importacoes/:id', element: guarded('imports.read', <ImportDetailPage />) },
      { path: 'configuracoes', element: guarded('settings.read', <SettingsPage />) },
      { path: 'minha-conta', element: <AccountPage /> },
      { path: 'usuarios', element: guarded('users.read', <UsersPage />) },
      { path: 'perfis', element: guarded('roles.read', <RolesPage />) },
      { path: 'auditoria', element: guarded('audit.read', <AuditPage />) },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
